import { IoLogOut, IoAdd } from 'react-icons/io5';

import Button from '../ui/Button';
import Card from '../ui/Card';

import classes from './Actions.module.css';

type ActionsProps = {
  onAddConsumptions?: React.MouseEventHandler<HTMLButtonElement>;
  onLogout?: React.MouseEventHandler<HTMLButtonElement>;
};

const Actions = ({ onAddConsumptions, onLogout }: ActionsProps) => {
  const cardStyles: React.CSSProperties = {
    flex: 0.1,
    flexDirection: 'row',
  };

  const buttonStyles: React.CSSProperties = {
    margin: '0 1em',
  };

  return (
    <Card extraStyles={cardStyles} withMargin="top">
      <Button onClick={onAddConsumptions} extraStyles={buttonStyles}>
        <IoAdd className={classes.icon} />
      </Button>
      <Button onClick={onLogout} extraStyles={buttonStyles}>
        <IoLogOut className={classes.icon} />
      </Button>
    </Card>
  );
};

export default Actions;
